import {IEvent} from '../../@interfaces/services/Events';

export default class Event implements IEvent {
	constructor(
		public name: string
	) {
	}
}
